import React from "react";
import classnames from "classnames";
import { useTranslation } from "react-i18next";

import { UseCases } from "@planzone/core";
import { useModal } from "@root/client/modal";
import { Props } from "./types";
import { AllocationsList } from "./allocationsList";
import { NameEditionForm } from "./nameEditionForm";
import { TaskAdvancement } from "./taskAdvancement";
import styles from "./styles.scss";

function Task({ task, project }: Props) {
  const isLate = !!task.endDate && new Date(task.endDate) < new Date();
  const { pushView } = useModal();
  const { t } = useTranslation();

  return (
    <div
      className={classnames(styles.task, { [styles.late]: isLate })}
      onClick={(e) =>
        e.target === e.currentTarget &&
        pushView({
          key: UseCases.retrieveTask,
          data: { task },
        })
      }
    >
      <div className={styles.name}>
        <NameEditionForm task={task} />
      </div>
      <p className={styles.status} style={{ color: task.status.color }}>
        {t(`taskStatuses.${task.status.label}`, task.status.label)}
      </p>
      <div className={styles.allocations}>
        <AllocationsList
          allocations={task.allocations}
          project={project}
          task={task}
        />
      </div>
      <div className={styles.taskAdvancement}>
        <div className={styles.taskAdvancementWrapper}>
          <TaskAdvancement
            progress={task.percentComplete}
            color={task.status.color}
            isCompleted={task.percentComplete >= 100}
          />
        </div>
      </div>
      {task.endDate ? (
        <p className={styles.text}>
          {new Date(task.endDate).toLocaleDateString()}
        </p>
      ) : (
        <p className={styles.text} />
      )}
    </div>
  );
}

export { Task };
